import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import themeNutriFast from '../styles/NutriFastColors';

const BreadcrumbNav = ({ items }) => {
  const navigate = useNavigate();

  if (!items || items.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast) {
            return (
              <Typography
                key={item.label}
                color="text.primary"
                sx={{
                  fontWeight: 500,
                  color: themeNutriFast.palette.primary.dark
                }}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={item.label}
              component="button"
              variant="body1"
              onClick={() => navigate(item.path)}
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                cursor: 'pointer',
                border: 'none',
                background: 'none',
                fontSize: 'inherit',
                fontFamily: 'inherit',
                '&:hover': {
                  color: themeNutriFast.palette.primary.dark,
                  textDecoration: 'underline'
                }
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbNav;
